import { FormatTypeCopySink } from './format-type.copysink';
import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { AvroDataset } from 'shell-models-lib';

@Metamodel.model({
    name: 'AvroSink',
    referable: true,
    tags: { datasetModel: Metamodel.modelFor(AvroDataset) }
})
export class AvroSink extends FormatTypeCopySink {
    public static readonly MODEL: IModel;
}
